import { createInertiaApp } from "@inertiajs/react"

import { captureClientException, initSentry } from "@/lib/sentry"
import { inertiaAppConfig } from "@/lib/inertia-app-config"

initSentry()

void createInertiaApp({
  // Must stay inline: @inertiajs/vite transforms `pages` via AST analysis.
  pages: "../pages",
  ...inertiaAppConfig,
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (typeof document !== "undefined" && document.getElementById("app")) {
    captureClientException(error)
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
        "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
        'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
